import Image from "next/image";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import EmphasizedText from "@/components/EmphasizedText";
import type { HeroProps } from "../types";

const SmallHero = ({
  title,
  titleOverride,
  children,
  image,
  path,
  hasBreadcrumbs = true,
  slant = false,
  stringToEmphasize,
}: HeroProps) => {
  return (
    <div className="bg-primary not-prose mx-break-out">
      <div className="container relative grid gap-2 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-4 md:px-6 pb-6 lg:pb-0 lg:px-8 mb-8">
        <div className="absolute inset-0 bg-black/40 not-prose mx-break-out lg:hidden" />

        <div className="col-span-1 lg:col-span-2 relative">
          <div className="relative z-10">
            {hasBreadcrumbs && path && (
              <Breadcrumbs variant="light" path={path} />
            )}
            <h1 className="text-[2rem] lg:text-[2.5rem] leading-[1.1] text-white font-bold mb-4 p-0 pt-6 mt-0">
              <EmphasizedText
                text={titleOverride || title}
                textEmphasis={stringToEmphasize}
              />
            </h1>
            <div className="[&>*]:text-white [&>p]:text-lg text-primary-foreground">
              {children ?? null}
            </div>
          </div>
        </div>

        {image?.sourceUrl && (
          <div className="hidden self-center md:block col-span-1 col-md-6 relative w-full md:h-[271px]">
            <div className="absolute md:inset-0 md:bg-black/40 md:z-10 lg:hidden" />

            <Image
              priority={true}
              src={image.sourceUrl}
              alt={image.altText ?? "hero"}
              fill={true}
              className={`object-cover self-center ${
                slant ? "clip-slant-left" : ""
              }`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SmallHero;
